// Mirrors MAX_SUBTITLE_LENGTH in the API (departments and locations subtitle, plain text)
export const MAX_SUBTITLE_LENGTH = 200

// Code points, like the API: an emoji is one character
export const isSubtitleTooLong = (value: string): boolean =>
  [...value.trim()].length > MAX_SUBTITLE_LENGTH
